jQuery(function () {
    let elements = document.querySelectorAll('.share_this button');

    if( elements.length ) {
        elements.forEach(element => {
            element.addEventListener('click', () => {
                navigator.clipboard.writeText(element.getAttribute('data-content'));
                element.classList.add('copied');
                setTimeout( () => {
                    element.classList.remove('copied');
                }, 4000);
            });
        });
    }
});